import { propertyNames } from './../../app/app.constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { tableNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { FirebaseProvider } from '../firebase/firebase';


@Injectable()
export class ConfigurationProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {}

  getSMS(userId?: string): Observable<boolean> {
    return this.firebaseService.propertyValue(this.getBaseRoot() + '/' + tableNames.User + '/' + (userId || this.globalVars.user.key) + '/' + tableNames.MicRRHH + '/' + propertyNames.SMS);
  }

  setSMS(sms: boolean, userId?: string) {
    return this.firebaseService.set(this.getBaseRoot() + '/' + tableNames.User + '/' + (userId || this.globalVars.user.key) + '/' + tableNames.MicRRHH, propertyNames.SMS, sms)
  }

  getPagesConfig(): Observable<any> {
    return this.firebaseService.object(this.getBaseRoot() + '/' + tableNames.Configuration)
  }

  setPagesConfig(pagesConfig: any) {
    delete pagesConfig.key;

    return this.firebaseService.set(this.getBaseRoot(), tableNames.Configuration, pagesConfig)
  }


  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/';
  }
}



// WEBPACK FOOTER //
// ./src/providers/configuration/configuration.ts